import request from '@/utils/request'
import locale from './../lang/i18n'
import { deleteMedia, getSettings, saveSettings, updateSettings, uploadMedia } from './adminV1'

function publicLocale () {
  return locale.locale === 'en-US' ? 'en' : 'zh-cn'
}

function getPublicAbout () {
  return request({ url: `/api/public/v1/${publicLocale()}/about`, method: 'get' })
}

function uploadSetting (file, field) {
  return uploadMedia(file, 'image')
    .then(media => updateSettings({ [field]: media.url }))
    .then(data => ({ code: 0, data }))
}

export function updateTopImg (file) {
  return uploadSetting(file, 'aboutTopImage')
}

export function getTopImg () {
  return getSettings().then(data => ({ code: 0, data: { value: data.aboutTopImage || '' } }))
}

export function getWebTopImg () {
  return getPublicAbout().then(data => ({ code: 0, data: { value: data.topImage } }))
}

export function updateCompanyIntroImg (file) {
  return uploadSetting(file, 'homeAboutImage')
}

export function getCompanyIntroImg () {
  return getSettings().then(data => ({ code: 0, data: { value: data.homeAboutImage || '' } }))
}

export function updateIndustryImg (file) {
  return uploadSetting(file, 'aboutIndustryImage')
}

export function updateIndustryImg2 (file) {
  return uploadSetting(file, 'aboutIntroImage')
}

export function updateIndustryImg3 (file) {
  return uploadSetting(file, 'aboutExtraImage')
}

export function getIndustryImg () {
  return getSettings().then(data => ({
    code: 0,
    data: {
      value: data.aboutIndustryImage || '',
      value2: data.aboutIntroImage || '',
      value3: data.aboutExtraImage || ''
    }
  }))
}

export function getWebIndustryImg () {
  return getPublicAbout().then(data => ({
    code: 0,
    data: { value: data.industryImage, value2: data.introImage, value3: data.extraImage }
  }))
}

export function uploadCertification (file) {
  return uploadMedia(file, 'image').then(media => getSettings().then(settings => {
    const values = [...(settings.aboutCertifications || []), media.url]
    return saveSettings({ ...settings, aboutCertifications: values })
  })).then(data => ({ code: 0, data }))
}

export function getCertification (query) {
  return getSettings().then(settings => {
    const values = settings.aboutCertifications || []
    const pageNum = Number((query && query.pageNum) || 1)
    const pageSize = Number((query && query.pageSize) || values.length || 8)
    const start = Math.max(0, (pageNum - 1) * pageSize)
    return { code: 0, data: { data: values.slice(start, start + pageSize), total: values.length } }
  })
}

export function getWebCertification (query) {
  return getPublicAbout().then(page => {
    const values = page.certifications || []
    const pageNum = Number((query && query.pageNum) || 1)
    const pageSize = Number((query && query.pageSize) || values.length || 8)
    const start = Math.max(0, (pageNum - 1) * pageSize)
    return { code: 0, data: { data: values.slice(start, start + pageSize), total: values.length } }
  })
}

export function delCertification (url) {
  return getSettings()
    .then(settings => saveSettings({
      ...settings,
      aboutCertifications: (settings.aboutCertifications || []).filter(item => item !== url)
    }))
    .then(() => deleteMedia(url))
    .then(() => ({ code: 0 }))
}

export function addOrUpdate (data) {
  let values = data.valueData || data.aboutValues || []
  if (typeof values === 'string') {
    try { values = JSON.parse(values) } catch (e) { values = [] }
  }
  return updateSettings({
    aboutHtml: data.value || data.aboutHtml || '',
    aboutHtml2: data.value2 || data.aboutHtml2 || '',
    aboutValues: values
  }).then(result => ({ code: 0, data: result }))
}

export function getAboutWeContent () {
  return getPublicAbout().then(data => ({
    code: 0,
    data: { value: data.aboutHtml, value2: data.aboutHtml2, valueData: data.values || [] }
  }))
}

export function getAdminAboutSettings () {
  return getSettings().then(data => ({
    code: 0,
    data: { value: data.aboutHtml, value2: data.aboutHtml2, valueData: data.aboutValues || [] }
  }))
}
